// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared StatusBadge — global standard color system.
   Uses existing tokens (--success/--warning/--danger/--info/--accent-primary,
   --bg-secondary/--text-muted, --radius). Color is never the only signal —
   the label text is always shown. */

.ui-status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: var(--r-pill);
  font-size: 11.5px;
  font-weight: 700;
  line-height: 1.4;
  white-space: nowrap;
  text-transform: capitalize;
}

/* Small dot reinforces the state without relying on color alone
   (shape + position differs from text). */
.ui-status-badge__dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
  flex-shrink: 0;
}

/* Green — positive / settled */
.ui-status-badge--success {
  background: var(--ok-soft);
  color: var(--ok-ink);
}

/* Amber — in-progress / needs attention */
.ui-status-badge--warning {
  background: var(--warn-soft);
  color: var(--warn-ink);
}

/* Red — failed / rejected */
.ui-status-badge--danger {
  background: var(--err-soft);
  color: var(--err-ink);
}

/* Blue — informational */
.ui-status-badge--info {
  background: var(--info-soft);
  color: var(--info-ink);
}

/* Neutral-purple — cancelled / refunded / draft */
.ui-status-badge--neutral {
  background: var(--accent-soft);
  color: var(--accent-ink);
}

.ui-status-badge--muted {
  background: var(--bg-inset);
  color: var(--t-500);
}

/* Enterprise dot-style variant (reference screens): no filled pill, a solid
   color dot + neutral label text. Keeps the same tone colors on the dot. */
.ui-status-badge--dot {
  background: transparent;
  padding: 0;
  border-radius: 0;
  color: var(--text-primary);
  text-transform: none;
  font-weight: 500;
  gap: 7px;
}

.ui-status-badge--dot .ui-status-badge__dot {
  width: 7px;
  height: 7px;
}

/* Each tone keeps a colored dot but a readable neutral text in dot mode. */
.ui-status-badge--dot.ui-status-badge--success .ui-status-badge__dot { background: var(--success); }
.ui-status-badge--dot.ui-status-badge--warning .ui-status-badge__dot { background: var(--warning); }
.ui-status-badge--dot.ui-status-badge--danger .ui-status-badge__dot { background: var(--danger); }
.ui-status-badge--dot.ui-status-badge--info .ui-status-badge__dot { background: var(--info); }
.ui-status-badge--dot.ui-status-badge--neutral .ui-status-badge__dot { background: var(--text-muted); }
.ui-status-badge--dot.ui-status-badge--muted .ui-status-badge__dot { background: var(--text-muted); }

/* Glyph variant: the tone's icon replaces the dot inside the tinted pill.
   Purely a swap of the leading mark — tint, text colour and sizing all stay as
   they are, so a pill with a glyph and one with a dot line up in a table. */
.ui-status-badge--icon { gap: 5px; }
.ui-status-badge__glyph { flex: none; width: 13px; height: 13px; }
`, "",{"version":3,"sources":["webpack://./src/components/common/StatusBadge.css"],"names":[],"mappings":"AAAA;;;oCAGoC;;AAEpC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;0CAC0C;AAC1C;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA,0CAA0C;AAC1C;EACE,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA,4BAA4B;AAC5B;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA,kDAAkD;AAClD;EACE,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;2EAC2E;AAC3E;EACE,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,0BAA0B;EAC1B,oBAAoB;EACpB,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA,2EAA2E;AAC3E,uEAAuE,0BAA0B,EAAE;AACnG,uEAAuE,0BAA0B,EAAE;AACnG,sEAAsE,yBAAyB,EAAE;AACjG,oEAAoE,uBAAuB,EAAE;AAC7F,uEAAuE,6BAA6B,EAAE;AACtG,qEAAqE,6BAA6B,EAAE;;AAEpG;;4EAE4E;AAC5E,yBAAyB,QAAQ,EAAE;AACnC,0BAA0B,UAAU,EAAE,WAAW,EAAE,YAAY,EAAE","sourcesContent":["/* Shared StatusBadge — global standard color system.\n   Uses existing tokens (--success/--warning/--danger/--info/--accent-primary,\n   --bg-secondary/--text-muted, --radius). Color is never the only signal —\n   the label text is always shown. */\n\n.ui-status-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  border-radius: var(--r-pill);\n  font-size: 11.5px;\n  font-weight: 700;\n  line-height: 1.4;\n  white-space: nowrap;\n  text-transform: capitalize;\n}\n\n/* Small dot reinforces the state without relying on color alone\n   (shape + position differs from text). */\n.ui-status-badge__dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: currentColor;\n  flex-shrink: 0;\n}\n\n/* Green — positive / settled */\n.ui-status-badge--success {\n  background: var(--ok-soft);\n  color: var(--ok-ink);\n}\n\n/* Amber — in-progress / needs attention */\n.ui-status-badge--warning {\n  background: var(--warn-soft);\n  color: var(--warn-ink);\n}\n\n/* Red — failed / rejected */\n.ui-status-badge--danger {\n  background: var(--err-soft);\n  color: var(--err-ink);\n}\n\n/* Blue — informational */\n.ui-status-badge--info {\n  background: var(--info-soft);\n  color: var(--info-ink);\n}\n\n/* Neutral-purple — cancelled / refunded / draft */\n.ui-status-badge--neutral {\n  background: var(--accent-soft);\n  color: var(--accent-ink);\n}\n\n.ui-status-badge--muted {\n  background: var(--bg-inset);\n  color: var(--t-500);\n}\n\n/* Enterprise dot-style variant (reference screens): no filled pill, a solid\n   color dot + neutral label text. Keeps the same tone colors on the dot. */\n.ui-status-badge--dot {\n  background: transparent;\n  padding: 0;\n  border-radius: 0;\n  color: var(--text-primary);\n  text-transform: none;\n  font-weight: 500;\n  gap: 7px;\n}\n\n.ui-status-badge--dot .ui-status-badge__dot {\n  width: 7px;\n  height: 7px;\n}\n\n/* Each tone keeps a colored dot but a readable neutral text in dot mode. */\n.ui-status-badge--dot.ui-status-badge--success .ui-status-badge__dot { background: var(--success); }\n.ui-status-badge--dot.ui-status-badge--warning .ui-status-badge__dot { background: var(--warning); }\n.ui-status-badge--dot.ui-status-badge--danger .ui-status-badge__dot { background: var(--danger); }\n.ui-status-badge--dot.ui-status-badge--info .ui-status-badge__dot { background: var(--info); }\n.ui-status-badge--dot.ui-status-badge--neutral .ui-status-badge__dot { background: var(--text-muted); }\n.ui-status-badge--dot.ui-status-badge--muted .ui-status-badge__dot { background: var(--text-muted); }\n\n/* Glyph variant: the tone's icon replaces the dot inside the tinted pill.\n   Purely a swap of the leading mark — tint, text colour and sizing all stay as\n   they are, so a pill with a glyph and one with a dot line up in a table. */\n.ui-status-badge--icon { gap: 5px; }\n.ui-status-badge__glyph { flex: none; width: 13px; height: 13px; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
